const EN = {
    title: 'Welcome!',
    inputs: {
        email: {
            label: 'Email',
            tip: 'Enter your registered email'
        },
        password: {
            label: 'Password'
        },
    },
    forgot: {
        title: 'Forgot password',
        description: 'We will send you an email to help you to create the password in a simple way.',
        error: 'Some of the data entered is incorrect. Please try again.',
        success: 'We have sent you an email to recover your password.'
    },
    error: 'Some of the data entered is incorrect. Please try again.',
    register: {
        title: 'Create account'
    },
    general: {
        forgotButton: 'Forgot password?',
        chip: 'BACK OFFICE'
    },
    otp: {
        title: 'Enter the code',
        inputLabel: 'Code',
        subtitle: 'We sent you a code by email, enter it below',
        resend: {
            question: 'Didn\'t receive the email yet?',
            action: 'Resend',
            success: 'We resent the code to your email.',
            sent: 'Code resent',
            alreadySent: 'We sent you a new code. Please check your email.',
            notExpired: 'Your code is still valid. Please check your email.'
        },
        submit: 'Validate code',
        codeError: 'Some of the data entered is incorrect. Please try again.',
        expired: 'Your code expired. Request a new one to continue.',
        emailChange: {
            success: 'Email validated successfully'
        }
    }
};

export default EN;
